import { TagColetorView } from "./view-tag-coletor";
import type { TagColetorProps } from "./types-tag-coletor";

export function TagColetor(props: TagColetorProps) {
  return <TagColetorView {...props} />;
}

export type * from "./types-tag-coletor";
